import { dequal } from 'dequal';

import type { ProductSetAction } from 'src/app/v1/state/types/productSet';
import type { ProductSetFromMutation } from 'src/types/product';

const defaultState: ProductSetFromMutation | null = null;

const RESET = 'session/productSet/RESET';
const UPDATE = 'session/productSet/UPDATE';

export const actionResetProductSet = () => ({
  type: RESET,
});

export const actionUpdateProductSet = (
  value: ProductSetFromMutation | null,
) => ({
  type: UPDATE,
  value,
});

export default (
  state: ProductSetFromMutation | null = defaultState,
  action: ProductSetAction,
) => {
  switch (action.type) {
    case RESET: {
      return defaultState;
    }
    case UPDATE: {
      return dequal(state, action.value) ? state : action.value;
    }
    default: {
      return state;
    }
  }
};

export const forTest = {
  RESET,
  UPDATE,
};
